import { render, staticRenderFns } from "./BotCommands.vue?vue&type=template&id=2669b8e6&scoped=true&lang=pug"
import script from "./BotCommands.vue?vue&type=script&lang=js"
export * from "./BotCommands.vue?vue&type=script&lang=js"
import style0 from "./BotCommands.vue?vue&type=style&index=0&id=2669b8e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669b8e6",
  null
  
)

export default component.exports